import React, {FC} from 'react';

import {ApproveShield, Icon, PackagesMini} from '@optimaxdev/icons';
import classNames from 'classnames';

import s from './shippingProtection.scss';

type PropsType = {
    showPackageIcon?: boolean;
};

/**
 * Shipping protection icon
 */
export const ShippingProtectionIcon: FC<PropsType> = ({showPackageIcon}) => (
    <div
        className={classNames(s.iconContainer, {
            [s.withPackageIcon]: showPackageIcon,
        })}
    >
        <Icon className={classNames(s.icon, s.packageIcon)} icon={PackagesMini} />
        <span className={s.shieldIconWrapper}>
            <Icon className={classNames(s.icon, s.shieldIcon)} icon={ApproveShield} />
        </span>
    </div>
);
